export default __webpack_public_path__ + "static/media/Intertek.429dde87.png";